var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusVectorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11103_78619)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1294,
    transform: "translate(-1767 -252)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: -10,
    width: 146,
    height: 40,
    rx: 6,
    fill: "#605BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2718 0.833374C17.3885 0.833374 19.1668 2.59337 19.1668 5.71921V14.2809C19.1668 17.3884 17.3977 19.1667 14.281 19.1667H5.71933C2.5935 19.1667 0.833496 17.3884 0.833496 14.2809V5.71921C0.833496 2.59337 2.5935 0.833374 5.71933 0.833374H14.2718ZM9.991 5.88421C9.56933 5.88421 9.23016 6.22337 9.23016 6.64504V9.23004H6.636C6.43433 9.23004 6.24183 9.31254 6.09516 9.45004C5.95766 9.59671 5.87516 9.78829 5.87516 9.99087C5.87516 10.4125 6.21433 10.7517 6.636 10.7609H9.23016V13.355C9.23016 13.7767 9.56933 14.1159 9.991 14.1159C10.4127 14.1159 10.7518 13.7767 10.7518 13.355V10.7609H13.3552C13.7768 10.7517 14.116 10.4125 14.116 9.99087C14.116 9.56921 13.7768 9.23004 13.3552 9.23004H10.7518V6.64504C10.7518 6.22337 10.4127 5.88421 9.991 5.88421Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11103_78619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1294,
    fill: "white",
    transform: "translate(-1767 -252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusVectorGreen);
export default __webpack_public_path__ + "static/media/plus-vector-green.5df50e1a6adef7871ba317ee0403b58e.svg";
export { ForwardRef as ReactComponent };